import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQueryWithAuth } from "./hrmsNotifications";
import Apis from "../../utils/apis";

export const referralList = createApi({
  reducerPath: "referralList",
  baseQuery: baseQueryWithAuth,
  tagTypes: ["Referral"],
  endpoints: (builder) => ({
    getReferralData: builder.query({
      query: ({ page = 1, limit, search, pagination = true }) => ({
        url: `${Apis.referralList}`,
        params: {
          page,
          limit,
          search,
          pagination,
        },
      }),
      providesTags: ["Referral"],
      keepUnusedDataFor: 300,
    }),
  }),
});

export const { useGetReferralDataQuery } = referralList;
